const BRANDS = [
  { name: "KalingaStone", img: "/assets/brands/kalingastone.png", h: "h-8 md:h-10" },
  { name: "Paradigm Quartz", img: "/assets/brands/paradigm.png", h: "h-16 md:h-20" },
  { name: "Motto Stone", img: "/assets/brands/motto.png", h: "h-9 md:h-11" },
  { name: "Somany Max", img: "/assets/brands/somany.png", h: "h-11 md:h-14" },
  { name: "Varmora", img: "/assets/brands/varmora.png", h: "h-9 md:h-11" },
  { name: "AGL", img: "/assets/brands/agl.png", h: "h-8 md:h-10" },
];

export default function BrandStrip() {
  return (
    <section data-testid="brand-strip" className="border-y border-border bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-14">
        <p className="text-center text-[10px] tracking-[0.3em] uppercase text-secondary-foreground mb-8 md:mb-10">
          Authorised dealers for
        </p>
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-x-10 gap-y-8 md:gap-x-6">
          {BRANDS.map((b) =>
            b.img ? (
              <img
                key={b.name}
                src={b.img}
                alt={b.name}
                data-testid={`brand-logo-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`${b.h} w-auto object-contain opacity-85 transition-opacity duration-500 hover:opacity-100`}
              />
            ) : (
              <span
                key={b.name}
                data-testid={`brand-logo-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm md:text-base font-medium tracking-[0.22em] text-foreground/60 transition-colors duration-500 hover:text-foreground"
              >
                {b.text}
              </span>
            )
          )}
        </div>
      </div>
    </section>
  );
}
